"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");
var _typeof = require("@babel/runtime/helpers/typeof");
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
var _classCallCheck2 = _interopRequireDefault(require("@babel/runtime/helpers/classCallCheck"));
var _createClass2 = _interopRequireDefault(require("@babel/runtime/helpers/createClass"));
var _possibleConstructorReturn2 = _interopRequireDefault(require("@babel/runtime/helpers/possibleConstructorReturn"));
var _getPrototypeOf2 = _interopRequireDefault(require("@babel/runtime/helpers/getPrototypeOf"));
var _inherits2 = _interopRequireDefault(require("@babel/runtime/helpers/inherits"));
var _defineProperty2 = _interopRequireDefault(require("@babel/runtime/helpers/defineProperty"));
var _react = _interopRequireWildcard(require("react"));
var _reactDom = _interopRequireDefault(require("react-dom"));
var _SkipLink = _interopRequireDefault(require("./SkipLink"));
function _interopRequireWildcard(e, t) { if ("function" == typeof WeakMap) var r = new WeakMap(), n = new WeakMap(); return (_interopRequireWildcard = function _interopRequireWildcard(e, t) { if (!t && e && e.__esModule) return e; var o, i, f = { __proto__: null, default: e }; if (null === e || "object" != _typeof(e) && "function" != typeof e) return f; if (o = t ? n : r) { if (o.has(e)) return o.get(e); o.set(e, f); } for (var _t in e) "default" !== _t && {}.hasOwnProperty.call(e, _t) && ((i = (o = Object.defineProperty) && Object.getOwnPropertyDescriptor(e, _t)) && (i.get || i.set) ? o(f, _t, i) : f[_t] = e[_t]); return f; })(e, t); }
function _callSuper(t, o, e) { return o = (0, _getPrototypeOf2.default)(o), (0, _possibleConstructorReturn2.default)(t, _isNativeReflectConstruct() ? Reflect.construct(o, e || [], (0, _getPrototypeOf2.default)(t).constructor) : o.apply(t, e)); }
function _isNativeReflectConstruct() { try { var t = !Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {})); } catch (t) {} return (_isNativeReflectConstruct = function _isNativeReflectConstruct() { return !!t; })(); }
var SkipLinks = /*#__PURE__*/function (_Component) {
  function SkipLinks() {
    var _this;
    (0, _classCallCheck2.default)(this, SkipLinks);
    for (var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }
    _this = _callSuper(this, SkipLinks, [].concat(args));
    // Workaround for an issue with hydrating portals https://github.com/facebook/react/issues/13097
    (0, _defineProperty2.default)(_this, "state", {
      mounted: false
    });
    return _this;
  }
  (0, _inherits2.default)(SkipLinks, _Component);
  return (0, _createClass2.default)(SkipLinks, [{
    key: "componentDidMount",
    value: function componentDidMount() {
      // eslint-disable-next-line react/no-did-mount-set-state
      this.setState({
        mounted: true
      });
    }
  }, {
    key: "render",
    value: function render() {
      var links = this.props.links;
      return this.state.mounted && /*#__PURE__*/_reactDom.default.createPortal(links.map(function (link, idx) {
        return /*#__PURE__*/_react.default.createElement(_SkipLink.default, {
          key: idx,
          id: link.id
        }, link.text);
      }), global.document.getElementById('skip-links'));
    }
  }]);
}(_react.Component);
(0, _defineProperty2.default)(SkipLinks, "defaultProps", {
  links: [{
    id: 'main',
    text: 'Jump to main content'
  }]
});
var _default = exports.default = SkipLinks;
//# sourceMappingURL=SkipLinks.js.map